import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiText,
  EuiIcon,
  EuiLink,
  useEuiTheme,
} from "@inscopix/ideas-eui";
import { Tooltip } from "components/Tooltip/Tooltip";
import { ReactComponent as IconBolt } from "assets/bolt.svg";
import { DataTableStoreState } from "../store/DataTableProvider.types";

interface DataTableCachingStatusProps {
  selectedTable: Extract<
    DataTableStoreState["tables"][number],
    { kind: "analysis" | "workflow" }
  >;
  onClick?: () => void;
}

export const DataTableCachingStatus = ({
  selectedTable,
  onClick,
}: DataTableCachingStatusProps) => {
  const { euiTheme } = useEuiTheme();

  const cachingColor = selectedTable.cache_enabled
    ? "subdued"
    : euiTheme.colors.disabledText;

  const label = `Caching ${selectedTable.cache_enabled ? "enabled" : "disabled"}`;

  return (
    <Tooltip content={<p>{label}</p>}>
      <EuiFlexGroup responsive={false} alignItems="center" gutterSize="xs">
        <EuiFlexItem grow={false}>
          <EuiIcon type={IconBolt} color={cachingColor} size="m" />
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiText color={cachingColor} size="s">
            {onClick !== undefined ? (
              <EuiLink onClick={onClick} style={{ color: "inherit" }}>
                {label}
              </EuiLink>
            ) : (
              label
            )}
          </EuiText>
        </EuiFlexItem>
      </EuiFlexGroup>
    </Tooltip>
  );
};
